<template>
  <div class='start-wrapper'>
    <!-- <div class="language-button">
      <a class="el-button el-button--info" href="https://cn.yundaorders.com" style="text-decoration: none; color: #f0f0f0; font-weight: bold;">中文简体</a>
    </div> -->
    <div class='start-form'>
      <img src="..\..\public\images\58brother logo.png" alt="yundaLogo" class='yunda-logo' width="100px">
      <div class="form-1">
        <h2>Enter your Email Address to start</h2>
        <input type="email" class="email-input" v-model="emailInput" autofocus>
        <div class="help-text">{{ warningTxt }}</div>
        <button class='start-button' @click="toLog">Log In/Sign Up</button>
        <!-- <div class="guest-start" @click="guestStart">Start as guest</div> -->
        <!-- <div class='button-group'>
          <button class='start-button' @click="toForm">Quick Start</button>
        </div> -->

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable handle-callback-err */

import MaterialDesignInput from '@/components/MaterialDesignInput'

export default {
  name: 'HomeStart',
  data () {
    return {
      emailInput: '',
      warningTxt: ''
    }
  },
  methods: {
    guestStart: function () {
      this.$emit('guest-start', this.emailInput)
    },
    toLog: function () {
      var re = /\S+@\S+/
      var result = re.test(String(this.emailInput).toLowerCase())
      if (!result) {
        this.warningTxt = 'Please enter valid email address'
        return
      }
      if (result) {
        this.warningTxt = ''
      }
      this.$emit('to-log', this.emailInput)
    }
  },
  watch: {
    emailInput: function () {
      var re = /\S+@\S+/
      var result = re.test(String(this.emailInput).toLowerCase())
      if (!result) {
        this.warningTxt = 'Please enter valid email address'
      } else {
        this.warningTxt = ''
      }
    }
  },
  components: {
    MaterialDesignInput
  }
}
</script>

<style>
.start-wrapper {
  background-color: #494949;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
}
.start-form {
  width: 900px;
  margin: 60px auto auto auto;
}
.yunda-logo {
  width: 160px;
  margin: auto;
  padding-bottom: 40px;
}
.start-button {
  margin-top: 40px;
  width: 200px;
  height: 60px;
  background-color: #fbc02d;
  color: #ffffff;
  border-radius: 40px;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.4s ease
}
.start-button:hover {
  box-shadow: 0 28px 50px -25px #F9A825;
}
.my-dash-button {
  color: #fbc02d;
  margin-left: 42px;
  margin-top: 5vh;
  width: 200px;
  font-size: 20px;
  padding: 12px;
  background-color: transparent;
  border-radius: 45px;
  border: 3px solid #fbc02d;
  cursor: pointer;
  transition: ease 0.4s all;
  font-family: 'Roboto', sans-serif;
}
.button-group {
  display: flex;
  justify-content: center;
}
.my-dash-button:hover {
  box-shadow: inset 0 4px 12px #fbc02d;
}
.language-button {
  position: fixed;
  top: 20px;
  right: 20px;
  font-weight: bold !important;
}
.guest-start {
  font-size: 20px;
  margin-top: 30px;
  text-decoration: underline;
  color: #494949;
  text-align: center;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .yunda-logo {
    width: 100px;
    margin: auto;
    padding-bottom: 30px;
  }
}
@media (max-width: 900px) {
  h2 {
    font-size: 24px;
  }
  .start-wrapper {
    overflow: auto;
  }
  .start-form {
    width: 80%;
    margin: auto;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  /* .start-button {
    margin-top: 20px;
    color: #ffffff;
    width: 120px;
    font-size: small;
    padding: 8px;
    background-color: #fbc02d;
    border-radius: 5px;
    border: none;
    font-family: 'Roboto', sans-serif;
  } */
  .warning {
    text-align: left
  }
  .yunda-logo {
    width: 80px;
    margin: auto;
    padding-bottom: 20px;
  }
  .button-group {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* .start-button {
    color: #ffffff;
    margin-top: 48px;
    width: 160px;
    font-size: medium;
    padding: 8px;
    background-color: #fbc02d;
    border-radius: 45px;
    border: 2px solid transparent;
    cursor: pointer;
    transition: ease 0.4s all;
    box-sizing: border-box;
  }
  .start-button:hover {
    box-shadow: 0 4px 8px 0 #c49000;
  } */
  .my-dash-button {
    color: #fbc02d;
    margin-top: 20px;
    margin-left: 0px;
    width: 160px;
    font-size: medium;
    padding: 8px;
    background-color: transparent;
    border-radius: 45px;
    border: 2px solid #fbc02d;
    cursor: pointer;
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif;
  }
}
</style>
